module.exports = __webpack_public_path__ + "static/FeatherBackground-772a25f2330d8cd9462c080d90d04dd6.png";